<template>
  <div class="component">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="headerPage">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 d-flex contentHeader">
            <div class="d-flex align-items-center" v-if="!id">
              <button
                class="btn btn-primary"
                v-on:click="openModal('number-code-modal')"
              >
                Selecionar máquina e APRs
              </button>
              <small class="ml-3">{{ machines.length }} máquinas cadastradas</small>
            </div>
          </div>
          <div class="col-6 d-flex contentHeaderRight">
            <!-- <div class="icon">
              <font-awesome-icon icon="print" />
            </div>-->
            <!-- <b-dropdown text="Exportar" class="m-md-2">
              <b-dropdown-item>PDF</b-dropdown-item>
              <b-dropdown-item>CSV</b-dropdown-item>
            </b-dropdown>-->
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ref="number-code-modal"
      title="Novo Plano de Ação"
      modal-ok="Sim"
      modal-cancel="Não"
      @ok="handleOk"
    >
      <div class="form-group">
        <label>Selecione uma máquina</label>
        <multiselect
          v-model="selectedMachine"
          :options="machines"
          track-by="id"
          label="name"
          placeholder="Selecione uma máquina"
          :searchable="true"
          :allow-empty="false"
          :clear-on-select="false"
          :close-on-select="true"
          :disabled="isMachineSelected"
          @input="onMachineChange"
        />
      </div>
      <div class="form-group">
        <label>Selecione uma ou mais APR's</label>
        <multiselect
          v-model="selected_aprs"
          :multiple="true"
          :options="aprs"
          track-by="id"
          label="nameWithMachine"
          placeholder="Selecione uma ou mais APR's"
          :disabled="!selectedMachine.id"
        ></multiselect>
      </div>
      <b-alert v-show="alert_field" :variant="alert_field_type" show>{{
        alert_field_msg
      }}</b-alert>

      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Ok</template>
    </b-modal>

    <div class="container-fluid" v-if="isMachineSelected">
      <div class="row">
        <div class="col-12 navBarSection">
          <div
            class="navBarItem"
            v-bind:class="{ active: isSelectedSection('plano_de_acao') }"
            v-on:click="selectSection('plano_de_acao')"
          >
            <font-awesome-icon icon="suitcase" />
            <span>PLANO DE AÇÃO</span>
          </div>

          <!-- <div
            class="navBarItem"
            v-bind:class="{'active': isSelectedSection('anexos')}"
            v-on:click="selectSection('anexos')"
          >
            <font-awesome-icon icon="paperclip" />
            <span>ANEXOS</span>
          </div>-->
        </div>
      </div>
      <div class="row actionPlan" v-if="isSelectedSection('plano_de_acao')">
        <div class="col-8">
          <div class="filter">
            <!-- <button
              v-on:click="openModal('number-code-modal')"
              class="btn btn-secondary float-left"
            >+ APR</button> -->
          </div>
          <div v-if="render" class="w-100">
            <div
              v-for="(action_plan, index) in action_plans"
              v-bind:key="index"
            >
              <div
                v-if="
                  index == 0 ||
                  action_plan.hazard.name !=
                    action_plans[index - 1].hazard.name
                "
                class="mt-5"
              >
                <label style="font-size: 18px">
                  <strong>Risco: {{ action_plan.hazard.name }}</strong>
                </label>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label for>Avaliação Inicial de Risco</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="action_plan.hrnLevel"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label>Categoria de Segurança</label>
                      <input
                        type="text"
                        v-model="action_plan.hazard.category"
                        class="form-control"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Accordion>
                <template v-slot:title>
                  <span class="textGray">Ação de Melhoria:</span>
                  {{ action_plan.improvement_action.name }}
                </template>
                <!-- <template v-slot:titleWarning>APR</template> -->
                <template v-slot:body>
                  <ActionPlan
                    ref="action_plan"
                    @deleteActionPlan="deleteActionPlan"
                    :action_plan="action_plan"
                    :analyze_action_plan_id="ap_analyze.id"
                    @saveActionPlan="onSaveActionPlan"
                  ></ActionPlan>
                </template>
              </Accordion>
            </div>
          </div>
          <button
            class="btn btn-success float-right"
            v-on:click="saveDocument()"
          >
            <span>Salvar Documento <font-awesome-icon icon="save" /> </span>
          </button>
        </div>
        <div class="col-4">
          <div class="machine">
            <div class="title">MÁQUINA</div>
            <span class="machineName">{{ selectedMachine.name }}</span>
            <div class="imgContent">
              <img
                class="imgMachine"
                v-if="selectedMachine.photo && selectedMachine.photo.url"
                :src="selectedMachine.photo.url"
                alt
              />
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row attachments" v-if="isSelectedSection('anexos')">
        <div class="col-8" v-if="localCompanyId && id">
          <AttachmentsList :company_id="localCompanyId" typeDocument="action_plan_analyze" :document_id="id"></AttachmentsList>
        </div>
      </div>-->
    </div>
    <div class="col-12 mt-3">
      <b-alert v-show="success" variant="success" show
        >Plano de Ação Salvo</b-alert
      >
      <b-alert
        dismissible
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged"
        fade
        :show="dismissCountDown"
        variant="warning"
        >Você possui uma ou mais ações de melhoria sem salvar. Por favor, salve
        tudo para continuar</b-alert
      >
    </div>

    <div class="alertError" style="width: 100%; height: 50px"></div>

    <!-- <b-modal
      id="modal-1"
      title="Adicionando Novo Risco"
      modal-ok="Adicionar"
      modal-cancel="Cancelar"
      @ok="handleOk"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <b-alert v-show="alert_field" :variant="alert_field_type" show>{{alert_field_msg}}</b-alert>
          </div>
        </div>
      </div>
    </b-modal>-->
  </div>
</template>
<script>
import Accordion from "@/components/Accordion.vue";
import ActionPlan from "@/components/ActionPlan.vue";
// import AttachmentsList from "@/components/AttachmentsList.vue";
import axios from "@/api/axios";
import { canAccess } from "@/utils/canAccess";
import Multiselect from "vue-multiselect";

export default {
  name: "ActionPlanAnalyze",
  components: {
    ActionPlan,
    Accordion,
    Multiselect,
    // AttachmentsList
  },
  data() {
    return {
      selectedSection: "plano_de_acao",
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index",
        },
        {
          text: "",
          href: `#/admin/Documents/Company/${this.company_id || localStorage.getItem('company_id')}`,
        },
        {
          text: "Planos de Ação",
          href: `#/admin/Documents/ListDocuments/${this.company_id || localStorage.getItem('company_id')}/ActionPlan`,
        },
        {
          text: "Plano",
          active: true,
        },
      ],
      localCompanyId: this.company_id || localStorage.getItem('company_id'),
      company: {},
      machines: [],
      selectedMachine: {},
      selected_aprs: [],
      isMachineSelected: false,
      ap_analyze: {},
      aprs: [],
      aprSelected: "0",
      newRisk: "0",
      render: false,
      alert_field: false,
      alert_field_type: "success",
      alert_field_msg: "Item salvo com sucesso",
      registersStack: [],
      dismissSecs: 8,
      dismissCountDown: 0,
      success: false,
      warning: false,
      action_plans: [],
    };
  },
  props: {
    id: String,
    company_id: String,
  },
  watch: {
    company_id(newVal) {
      this.localCompanyId = newVal;
      if (newVal) {
        this.getCompany(newVal);
      }
    },
  },
  mounted: async function() {
    const loader = this.$loading.show();
    if (this.localCompanyId) {
      this.getCompany(this.localCompanyId);
    }
    if (this.id) {
      await this.getActionPlanAnalyze();
    } else {
      // this.generateNumberCode();
      await this.getMachinesByCompanyId();
    }
    loader.hide();
  },
  methods: {
    canAccess,
    getCompany: function (company_id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies/${company_id}`)
        .then((response) => {
          this.items[1].text = response.data.data.corporate_name;
        });
    },
    getMachinesByCompanyId: async function () {
      const response = await axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/machines`,
        {
          params: {
            include: 'protectionSystems,actionPlanAnalyzes',
            company_id: this.localCompanyId,
            not_paginated: true,
            not_gallery: true,
          },
        }
      );

      this.machines = response.data.data.filter(
        (machine) => machine.action_plan_analyzes.length === 0
      );
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    changeMachine: function () {
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/hazards-machine`, {
          machine_id: this.selectedMachine.id,
        })
        .then(() => {});
    },
    onSaveActionPlan: function () {
      this.registersStack.pop();
    },
    selectSection: function (section) {
      this.selectedSection = section;
    },
    isSelectedSection: function (section) {
      return this.selectedSection == section;
    },
    openModal: async function (modal) {
      if (modal == "number-code-modal") {
        await this.getMachinesByCompanyId();
        this.aprs = [];
        this.selected_aprs = [];
        this.selectedMachine = {};
      }
      this.$refs[modal].show();
    },
    saveDocument: function () {

      if (this.$refs.action_plan) {
        this.$refs.action_plan.forEach((el) => {
          console.log('Calling save on element:', el);
          if (el.save) {
            el.save();
          } else {
            console.log('Element does not have save method');
          }
        });
      } else {
        console.log('No action_plan refs found');
      }
      
      localStorage.setItem('actionplan_success_notification', 'true');
      
      setTimeout(() => {
        this.success = false;
        this.$router.push({
          name: 'ListDocuments',
          params: {
            company_id: this.company_id,
            doctype: 'ActionPlan',
            docTypeText: 'Plano de Ação'
          }
        });
        //redirect
      }, 1500);
    },
    createActionPlan: async function () {
      this.isMachineSelected = true;
      this.render = false;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_HOST}/api/admin/action-plan-analyze`,
          {
            name: this.selectedMachine.name,
            machine_id: this.selectedMachine.id,
            hazard_analysis_ids: this.selected_aprs.map((apr) => apr.id),
          }
        );

        this.ap_analyze = response.data;
        this.id = this.ap_analyze.id;
        this.company_id =
          this.ap_analyze?.machine?.company?.id || this.company_id;
        this.prepareActionPlans(
          this.ap_analyze.action_plans_sorted || this.ap_analyze.action_plans || []
        );
      } catch (error) {
        this.warning = true;
      }
    },
    onMachineChange: async function () {
      this.selected_aprs = [];
      await this.getAPRs();
    },
    getAPRs: async function () {
      if (!this.selectedMachine.id) return;
      await axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/hazards-machine`, {
          machine_id: this.selectedMachine.id,
        })
        .then((response) => {
          this.aprs = response.data.data || response.data;
          this.aprs.forEach((apr) => {
            apr.nameWithMachine = `${apr.number_code} - ${apr.machine.name}`;
          });
        });
    },
    resetModal() {},
    handleOk: function (bvModalEvt) {
      if (this.selected_aprs.length > 0 && this.selectedMachine.id) {
        this.createActionPlan();
      } else {
        bvModalEvt.preventDefault();
        this.alert_field_type = "warning";
        this.alert_field_msg = "Por favor, selecione a máquina e ao menos uma APR";
        this.alert_field = true;
        const vm = this;
        setTimeout(() => {
          vm.alert_field = false;
        }, 3000);
      }
    },
    prepareActionPlans(actionPlans) {
      const plans = actionPlans.map((action_plan) => {
        const hazard =
          action_plan.improvement_action?.hazard || action_plan.hazard;

        return {
          ...action_plan,
          hazard,
          hrnLevel: hazard?.hrn?.hrn_level || null,
        };
      });

      this.action_plans = this.sortActionPlans(plans);
      this.registersStack = this.action_plans.map(
        () => "uma ação de melhoria"
      );
      this.render = true;
      this.resetModal();
    },

    getActionPlanAnalyze: async function () {
      await axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/admin/action-plan-analyze/${this.id}`
        )
        .then(async (response) => {
          this.ap_analyze = response.data;
          const normalizedActions = [];
          this.ap_analyze.action_plans_sorted.forEach((action_plan) => {
            const hazard = action_plan.improvement_action?.hazard;
            if (!hazard) {
              return;
            }

            action_plan.hazard = hazard;
            action_plan.hrnLevel = hazard.hrn?.hrn_level || null;
            action_plan.investment_amount = Number(action_plan.investment_amount) || 0;

            if (
              hazard.hazard_analysis &&
              !this.selected_aprs.find(
                (apr) => apr.id == hazard.hazard_analysis.id
              )
            ) {
              this.selected_aprs.push(hazard.hazard_analysis);
            }

            normalizedActions.push(action_plan);
          });

          this.action_plans = normalizedActions;
          this.name_action_plan = this.ap_analyze.name;
          this.selectedMachine = this.ap_analyze.machine;
          this.isMachineSelected = true;
          this.render = true;
          this.company_id = this.ap_analyze.machine.company.id;
          await this.getAPRs();
        });
    },
    calculateHRN: function (hazard) {
      let promise = axios.post(
        `${process.env.VUE_APP_API_HOST}/api/admin/calculate-hrn`,
        {
          np: hazard.score_np,
          dph: hazard.score_dph,
          fe: hazard.score_fe,
          lo: hazard.score_lo,
        }
      );

      return promise;
    },

    deleteActionPlan: function (val) {
      this.action_plans.splice(val, 1);
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("alertError")[0];
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    sortActionPlans: function(actionPlans = this.action_plans) {
      return [...actionPlans].sort(function(a,b) {
        const hazardA = a.hazard?.name || "";
        const hazardB = b.hazard?.name || "";
        return (hazardA > hazardB) ? 1 : ((hazardB > hazardA) ? -1 : 0);
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
    // if (this.registersStack.length > 0) {
    //   this.dismissCountDown = this.dismissSecs;
    //   this.scrollToElement();
    //   next(false);
    // } else {
    //   next();
    // }
  },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "src/styles/General.scss";
@import "src/styles/ActionPlan.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
